import { useCallback } from "react";

import { SectionRole } from "../../shared/types/roles";

import { storeApi, useAppSelector } from "store/index";
import {
  selectCurrentClassUserId,
  selectCurrentSectionId,
  selectCurrentSectionUserId,
  selectCurrentUserId,
} from "store/selectors";

export const useJoinAsSectionAssistant = () => {
  const currentSectionUserId = useAppSelector(selectCurrentSectionUserId);
  const currentUserId = useAppSelector(selectCurrentUserId);
  const currentSectionId = useAppSelector(selectCurrentSectionId);
  const currentClassUserId = useAppSelector(selectCurrentClassUserId);

  const joinAsSectionAssistantIfNew = useCallback(async () => {
    let classUserId = currentClassUserId;

    if (!currentSectionUserId) {
      await storeApi.section_users.create({
        section_id: currentSectionId!,
        user_id: currentUserId!,
        role: SectionRole.SECTION_ASSISTANT,
      });
    }

    if (!classUserId) {
      classUserId = (
        await storeApi.class_users.create({
          section_id: currentSectionId!,
          user_id: currentUserId!,
        })
      )?.id;
    }

    return { classUserId };
  }, [currentSectionUserId, currentSectionId, currentUserId, currentClassUserId]);

  return { joinAsSectionAssistantIfNew };
};
